import { UIEvent } from 'react';

import config from 'config';

import { ListComponentsTalkTo } from './components.styles';
import { PhoneLink } from './PhoneLink';
import { WhatsappLink } from './WhatsappLink';

export const ListComponentIsRow = ({
  handleTrackClick,
}: {
  handleTrackClick: (event: UIEvent<HTMLAnchorElement>) => void;
}) => (
  <>
    <ListComponentsTalkTo.Div>
      <WhatsappLink handleTrackClick={handleTrackClick} />
      {config.communication.sac.phone && <PhoneLink handleTrackClick={handleTrackClick} />}
    </ListComponentsTalkTo.Div>
    {config.communication.sac.phone && (
      <ListComponentsTalkTo.Li>
        Ligação gratuita de qualquer lugar do país tanto de telefone fixo quanto de celular
      </ListComponentsTalkTo.Li>
    )}
  </>
);
